export const workFlowAccessLevel = {
  EXECUTE: 'execute',
  EDIT: 'edit',
  EDIT_CONTENT: 'edit-content',
  OWNER: 'owner',
};

export const workFlowAccessLevels = [
  { name: workFlowAccessLevel.EXECUTE, caption: 'Kann ausführen' },
  { name: workFlowAccessLevel.EDIT_CONTENT, caption: 'Kann formatieren' },
  { name: workFlowAccessLevel.EDIT, caption: 'Kann bearbeiten' },
  { name: workFlowAccessLevel.OWNER, caption: 'Besitzer' },
];
